/* eslint-disable max-len */
import React from 'react';

function PrivacyPL() {
  return (
    <div id="pp" style={{ fontSize: '20px !important' }}>
      <span>Poniższa Polityka Prywatności określa </span>
      <b> zasady zapisywania i uzyskiwania dostępu do danych na Urządzeniach Użytkowników</b>
      <span> korzystających z Serwisu do celów świadczenia usług drogą elektroniczną przez Administratora oraz </span>
      <b> zasady gromadzenia i przetwarzania danych osobowych Użytkowników</b>
      <span>, które zostały podane przez nich osobiście i dobrowolnie za pośrednictwem narzędzi dostępnych w Serwisie.</span>

      <span>Poniższa Polityka Prywatności jest integralną częścią </span>
      <a href="https://www.actman.pl/rodo"><span>Regulaminu Serwisu</span></a>
      <span>, który określa zasady, prawa i obowiązki Użytkowników korzystających z Serwisu.</span>
      <h2><b>§1 Definicje</b></h2>
      <ul>
        <li aria-level="1">
          <b>Serwis</b>
          <span> - serwis internetowy &quot;actman.pl&quot; działający pod adresem https://www.actman.pl/</span>
        </li>
        <li aria-level="1">
          <b>Serwis zewnętrzny</b>
          <span> - serwisy internetowe partnerów, usługodawców lub usługobiorców współpracujących z Administratorem.</span>
        </li>
        <li aria-level="1">
          <b>Administrator Serwisu / Danych</b>
          <span> - Administratorem Serwisu oraz Administratorem Danych (dalej Administrator) jest firma &quot;Active Management Sp. z o. o. sp. k.&quot;, prowadząca działalność pod adresem: ul. Urzędnicza 16/2, 30-051 Kraków, o nadanym numerze identyfikacji podatkowej (NIP): 6772377848, o nadanym numerze KRS: 0000600408, świadcząca usługi drogą elektroniczną za pośrednictwem Serwisu.</span>
        </li>
        <li aria-level="1">
          <b>Użytkownik</b>
          <span> - osoba fizyczna, dla której Administrator świadczy usługi drogą elektroniczną za pośrednictwem Serwisu.</span>
        </li>
        <li aria-level="1">
          <b>Urządzenie</b>
          <span> - elektroniczne urządzenie wraz z oprogramowaniem, za pośrednictwem którego Użytkownik uzyskuje dostęp do Serwisu.</span>
        </li>
        <li aria-level="1">
          <b>Cookies (ciasteczka)</b>
          <span> - dane tekstowe gromadzone w formie plików zamieszczanych na Urządzeniu Użytkownika.</span>
        </li>
        <li aria-level="1">
          <b>RODO</b>
          <span> - Rozporządzenie Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych).</span>
        </li>
        <li aria-level="1">
          <b>Dane osobowe</b>
          <span> - oznaczają informacje o zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej („osobie, której dane dotyczą”); możliwa do zidentyfikowania osoba fizyczna to osoba, którą można bezpośrednio lub pośrednio zidentyfikować, w szczególności na podstawie identyfikatora takiego jak imię i nazwisko, numer identyfikacyjny, dane o lokalizacji, identyfikator internetowy lub jeden bądź kilka szczególnych czynników określających fizyczną, fizjologiczną, genetyczną, psychiczną, ekonomiczną, kulturową lub społeczną tożsamość osoby fizycznej.</span>
        </li>
        <li aria-level="1">
          <b>Przetwarzanie</b>
          <span> - oznacza operację lub zestaw operacji wykonywanych na danych osobowych lub zestawach danych osobowych w sposób zautomatyzowany lub nie zautomatyzowany, taką jak zbieranie, utrwalanie, organizowanie, porządkowanie, przechowywanie, adaptowanie lub modyfikowanie, pobieranie, przeglądanie, wykorzystywanie, ujawnianie poprzez przesyłanie, rozpowszechnianie lub innego rodzaju udostępnianie, dopasowywanie lub łączenie, ograniczanie, usuwanie lub niszczenie.</span>
        </li>
        <li aria-level="1">
          <b>Ograniczenie przetwarzania</b>
          <span> - oznacza oznaczenie przechowywanych danych osobowych w celu ograniczenia ich przyszłego przetwarzania.</span>
        </li>
        <li aria-level="1">
          <b>Profilowanie</b>
          <span> - oznacza dowolną formę zautomatyzowanego przetwarzania danych osobowych, które polega na wykorzystaniu danych osobowych do oceny niektórych czynników osobowych osoby fizycznej, w szczególności do analizy lub prognozy aspektów dotyczących efektów pracy tej osoby fizycznej, jej sytuacji ekonomicznej, zdrowia, osobistych preferencji, zainteresowań, wiarygodności, zachowania, lokalizacji lub przemieszczania się.</span>
        </li>
        <li aria-level="1">
          <b>Zgoda</b>
          <span> - zgoda osoby, której dane dotyczą oznacza dobrowolne, konkretne, świadome i jednoznaczne okazanie woli, którym osoba, której dane dotyczą, w formie oświadczenia lub wyraźnego działania potwierdzającego, przyzwala na przetwarzanie dotyczących jej danych osobowych.</span>
        </li>
        <li aria-level="1">
          <b>Naruszenie ochrony danych osobowych</b>
          <span> - oznacza naruszenie bezpieczeństwa prowadzące do przypadkowego lub niezgodnego z prawem zniszczenia, utracenia, zmodyfikowania, nieuprawnionego ujawnienia lub nieuprawnionego dostępu do danych osobowych przesyłanych, przechowywanych lub w inny sposób przetwarzanych.</span>
        </li>
        <li aria-level="1">
          <b>Pseudonimizacja</b>
          <span> - oznacza przetwarzanie danych osobowych w taki sposób, by nie można ich było już przypisać konkretnej osobie, której dane dotyczą, bez użycia dodatkowych informacji, pod warunkiem że takie dodatkowe informacje są przechowywane osobno i są objęte środkami technicznymi i organizacyjnymi uniemożliwiającymi ich przypisanie zidentyfikowanej lub możliwej do zidentyfikowania osobie fizycznej.</span>
        </li>
        <li aria-level="1">
          <b>Anonimizacja</b>
          <span> - Anonimizacja danych to nieodwracalny proces operacji na danych, który niszczy / nadpisuje &quot;dane osobowe&quot; uniemożliwiając identyfikację, lub powiązanie danego rekordu z konkretnym użytkownikiem lub osobą fizyczną.</span>
        </li>
      </ul>
      <h2><b>§2 Inspektor Ochrony Danych</b></h2>
      <span>Na podstawie Art. 37 RODO, Administrator nie powołał Inspektora Ochrony Danych.</span>

      <span>W sprawach dotyczących przetwarzania danych, w tym danych osobowych, należy kontaktować się bezpośrednio z Administratorem.</span>
      <h2><b>§3 Rodzaje Plików Cookies</b></h2>
      <ul>
        <li aria-level="1">
          <b>Cookies wewnętrzne</b>
          <span> - pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez system teleinformatyczny Serwisu.</span>
        </li>
        <li aria-level="1">
          <b>Cookies zewnętrzne</b>
          <span> - pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez systemy teleinformatyczne Serwisów zewnętrznych. Skrypty Serwisów zewnętrznych, które mogą umieszczać pliki Cookies na Urządzeniach Użytkownika zostały świadomie umieszczone w Serwisie poprzez skrypty i usługi udostępnione i zainstalowane w Serwisie.</span>
        </li>
        <li aria-level="1">
          <b>Cookies sesyjne</b>
          <span> - pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez Serwis podczas jednej sesji danego Urządzenia. Po zakończeniu sesji pliki są usuwane z Urządzenia Użytkownika.</span>
        </li>
        <li aria-level="1">
          <b>Cookies trwałe</b>
          <span> - pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez Serwis do momentu ich ręcznego usunięcia. Pliki nie są usuwane automatycznie po zakończeniu sesji Urządzenia chyba że konfiguracja Urządzenia Użytkownika jest ustawiona na tryb usuwanie plików Cookie po zakończeniu sesji Urządzenia.</span>
        </li>
      </ul>
      <h2><b>§4 Bezpieczeństwo składowania danych</b></h2>
      <ul>
        <li aria-level="1">
          <b>Mechanizmy składowania i odczytu plików Cookie</b>
          <span> - Mechanizmy składowania, odczytu i wymiany danych pomiędzy Plikami Cookies zapisywanymi na Urządzeniu Użytkownika a Serwisem są realizowane poprzez wbudowane mechanizmy przeglądarek internetowych i nie pozwalają na pobieranie innych danych z Urządzenia Użytkownika lub danych innych witryn internetowych, które odwiedzał Użytkownik, w tym danych osobowych ani informacji poufnych. Przeniesienie na Urządzenie Użytkownika wirusów, koni trojańskich oraz innych robaków jest także praktycznie niemożliwe.</span>
        </li>
        <li aria-level="1">
          <b>Cookie wewnętrzne</b>
          <span> - zastosowane przez Administratora pliki Cookie są bezpieczne dla Urządzeń Użytkowników i nie zawierają skryptów, treści lub informacji mogących zagrażać bezpieczeństwu danych osobowych lub bezpieczeństwu Urządzenia z którego korzysta Użytkownik.</span>
        </li>
        <li aria-level="1">
          <b>Cookie zewnętrzne</b>
          <span> - Administrator dokonuje wszelkich możliwych działań w celu weryfikacji i doboru partnerów serwisu w kontekście bezpieczeństwa Użytkowników. Administrator do współpracy dobiera znanych, dużych partnerów o globalnym zaufaniu społecznym. Nie posiada on jednak pełnej kontroli nad zawartością plików Cookie pochodzących od zewnętrznych partnerów. Za bezpieczeństwo plików Cookie, ich zawartość oraz zgodne z licencją wykorzystanie przez zainstalowane w serwisie Skrypty, pochodzących z Serwisów zewnętrznych, Administrator nie ponosi odpowiedzialności na tyle na ile pozwala na to prawo. Lista partnerów zamieszczona jest w dalszej części Polityki Prywatności.</span>
        </li>
        <li aria-level="1">
          <b>Kontrola plików Cookie</b>
          <ul>
            <li aria-level="2"><span>Użytkownik może w dowolnym momencie, samodzielnie zmienić ustawienia dotyczące zapisywania, usuwania oraz dostępu do danych zapisanych plików Cookies przez każdą witrynę internetową</span></li>
            <li aria-level="2">
              <span>Informacje o sposobie wyłączenia plików Cookie w najpopularniejszych przeglądarkach komputerowych dostępne są na stronie: </span>
              <a href="https://nety.pl/jak-wylaczyc-pliki-cookie/"><span>jak wyłączyć cookie</span></a>
              <span> lub u jednego ze wskazanych dostawców:</span>
              <ul>
                <li aria-level="3">
                  <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&amp;hl=pl">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>Chrome</b>
                  </a>
                </li>
                <li aria-level="3">
                  <a href="https://help.opera.com/pl/latest/web-preferences/">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>Opera</b>
                  </a>
                </li>
                <li aria-level="3">
                  <a href="https://support.mozilla.org/pl/kb/blokowanie-ciasteczek">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>FireFox</b>
                  </a>
                </li>
                <li aria-level="3">
                  <a href="https://support.microsoft.com/pl-pl/help/4027947/microsoft-edge-delete-cookies">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>Edge</b>
                  </a>
                </li>
                <li aria-level="3">
                  <a href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>Safari</b>
                  </a>
                </li>
                <li aria-level="3">
                  <a href="https://windows.microsoft.com/pl-pl/internet-explorer/delete-manage-cookies#ie=ie-11">
                    <span>Zarządzanie plikami cookies w przeglądarce </span>
                    <b>Internet Explorer 11</b>
                  </a>
                </li>
              </ul>
            </li>
            <li aria-level="2"><span>Użytkownik może w dowolnym momencie usunąć wszelkie zapisane do tej pory pliki Cookie korzystając z narzędzi Urządzenia Użytkownika, za pośrednictwem którego Użytkownik korzysta z usług Serwisu.</span></li>
          </ul>
        </li>
        <li aria-level="1">
          <b>Zagrożenia po stronie Użytkownika </b>
          <span>- Administrator stosuje wszelkie możliwe środki techniczne w celu zapewnienia bezpieczeństwa danych umieszczanych w plikach Cookie. Należy jednak zwrócić uwagę, że zapewnienie bezpieczeństwa tych danych zależy od obu stron w tym działalności Użytkownika. Administrator nie bierze odpowiedzialności za przechwycenie tych danych, podszycie się pod sesję Użytkownika lub ich usunięcie, na skutek świadomej lub nieświadomej działalność Użytkownika, wirusów, koni trojańskich i innego oprogramowania szpiegującego, którymi może jest lub było zainfekowane Urządzenie Użytkownika. Użytkownicy w celu zabezpieczenia się przed tymi zagrożeniami powinni stosować się do </span>
          <a href="https://nety.pl/cyberbezpieczenstwo/zasady-ogolne-korzystania-z-sieci-internet/"><span>zasad bezpiecznego korzystania z sieci internet</span></a>
          <span>.</span>
        </li>
        <li aria-level="1">
          <b>Przechowywanie danych osobowych</b>
          <span> - Administrator zapewnia, że dokonuje wszelkich starań, by przetwarzane dane osobowe wprowadzone dobrowolnie przez Użytkowników były bezpieczne, dostęp do nich był ograniczony i realizowany zgodnie z ich przeznaczeniem i celami przetwarzania. Administrator zapewnia także, że dokonuje wszelkich starań w celu zabezpieczenia posiadanych danych przed ich utratą, poprzez stosowanie odpowiednich zabezpieczeń fizycznych jak i organizacyjnych.</span>
        </li>
      </ul>
      <h2><b>§5 Cele do których wykorzystywane są pliki Cookie</b></h2>
      <ul>
        <li aria-level="1"><span>Usprawnienie i ułatwienie dostępu do Serwisu.</span></li>
        <li aria-level="1"><span>Personalizacja Serwisu dla Użytkowników.</span></li>
        <li aria-level="1"><span>Prowadzenie statystyk (użytkowników, ilości odwiedzin, rodzajów urządzeń, łącze itp.).</span></li>
      </ul>
      <h2><b>§6 Cele przetwarzania danych osobowych</b></h2>
      <span>Dane osobowe dobrowolnie podane przez Użytkowników są przetwarzane w jednym z następujących celów:</span>
      <ul>
        <li aria-level="1"><span>Realizacji usług elektronicznych (w tym formularza kontaktowego).</span></li>
        <li aria-level="1"><span>Komunikacji Administratora z Użytkownikami w sprawach związanych z Serwisem oraz ochrony danych.</span></li>
        <li aria-level="1"><span>Zapewnienia prawnie uzasadnionego interesu Administratora.</span></li>
      </ul>
      <span>Dane o Użytkownikach gromadzone anonimowo i automatycznie są przetwarzane w jednym z następujących celów:</span>
      <ul>
        <li aria-level="1"><span>Prowadzenie statystyk.</span></li>
        <li aria-level="1"><span>Zapewnienia prawnie uzasadnionego interesu Administratora.</span></li>
      </ul>
      <h2><b>§7 Pliki Cookies Serwisów zewnętrznych</b></h2>
      <span>Administrator w Serwisie wykorzystuje skrypty javascript i komponenty webowe partnerów, którzy mogą umieszczać własne pliki cookies na Urządzeniu Użytkownika. Pamiętaj, że w ustawieniach swojej przeglądarki możesz sam decydować o dozwolonych plikach cookies jakie mogą być używane przez poszczególne witryny internetowe. Poniżej znajduje się lista partnerów lub ich usług zaimplementowanych w Serwisie, mogących umieszczać pliki cookies:</span>
      <ul>
        <li aria-level="1">
          <b>Prowadzenie statystyk:</b>
          <ul>
            <li aria-level="2"><a href="https://policies.google.com/privacy?hl=pl"><span>Google Analytics</span></a></li>
          </ul>
        </li>
      </ul>
      <span>Usługi świadczone przez podmioty trzecie są poza kontrolą Administratora. Podmioty te mogą w każdej chwili zmienić swoje warunki świadczenia usług, polityki prywatności, cel przetwarzania danych oraz sposób wykorzystywania plików cookie.</span>
      <h2><b>§8 Rodzaje gromadzonych danych</b></h2>
      <span>Serwis gromadzi dane o Użytkownikach. Część danych jest gromadzona automatycznie i anonimowo, a część danych to dane osobowe podane dobrowolnie przez Użytkowników w trakcie zapisywania się do poszczególnych usług oferowanych przez Serwis.</span>

      <b> Anonimowe dane gromadzone automatycznie: </b>
      <ul>
        <li aria-level="1"><span>Adres IP.</span></li>
        <li aria-level="1"><span>Typ przeglądarki.</span></li>
        <li aria-level="1"><span>Rozdzielczość ekranu.</span></li>
        <li aria-level="1"><span>Przybliżona lokalizacja.</span></li>
        <li aria-level="1"><span>Otwierane podstrony serwisu.</span></li>
        <li aria-level="1"><span>Czas spędzony na odpowiedniej podstronie serwisu.</span></li>
        <li aria-level="1"><span>Rodzaj systemu operacyjnego.</span></li>
        <li aria-level="1"><span>Adres poprzedniej podstrony.</span></li>
        <li aria-level="1"><span>Adres strony odsyłającej.</span></li>
        <li aria-level="1"><span>Język przeglądarki.</span></li>
        <li aria-level="1"><span>Prędkość łącza internetowego.</span></li>
        <li aria-level="1"><span>Dostawca usług internetowych.</span></li>
      </ul>
      <b>Dane gromadzone podczas przesyłania formularza kontaktowego:</b>
      <ul>
        <li aria-level="1"><span>Adres e-mail.</span></li>
        <li aria-level="1"><span>Adresy nieruchomości.</span></li>
        <li aria-level="1"><span>Adres IP (zbierane automatycznie).</span></li>
      </ul>
      <span>Część danych (bez danych identyfikujących) może być przechowywana w plikach cookies. Cześć danych (bez danych identyfikujących) może być przekazywana do dostawcy usług statystycznych.</span>
      <h2><b>§9 Dostęp do danych osobowych przez podmioty trzecie</b></h2>
      <span>Co do zasady jedynym odbiorcą danych osobowych podawanych przez Użytkowników jest Administrator. Dane gromadzone w ramach świadczonych usług nie są przekazywane ani odsprzedawane podmiotom trzecim.</span>
      <h2><b>§10 Sposób przetwarzania danych osobowych</b></h2>
      <b>Dane osobowe podane dobrowolnie przez Użytkowników:</b>
      <ul>
        <li aria-level="1"><span>Dane osobowe nie będą przekazywane poza Unię Europejską, chyba że zostały opublikowane na skutek indywidualnego działania Użytkownika (np. wprowadzenie komentarza lub wpisu), co sprawi, że dane będą dostępne dla każdej osoby odwiedzającej serwis.</span></li>
        <li aria-level="1"><span>Dane osobowe nie będą wykorzystywane do zautomatyzowanego podejmowania decyzji (profilowania).</span></li>
        <li aria-level="1"><span>Dane osobowe nie będą odsprzedawane podmiotom trzecim.</span></li>
      </ul>
      <b>Dane anonimowe (bez danych osobowych) gromadzone automatycznie:</b>
      <ul>
        <li aria-level="1"><span>Dane anonimowe (bez danych osobowych) będą przekazywane poza Unię Europejską.</span></li>
        <li aria-level="1"><span>Dane anonimowe (bez danych osobowych) nie będą wykorzystywane do zautomatyzowanego podejmowania decyzji (profilowania).</span></li>
        <li aria-level="1"><span>Dane anonimowe (bez danych osobowych) nie będą odsprzedawane podmiotom trzecim.</span></li>
      </ul>
      <h2><b>§11 Podstawy prawne przetwarzania danych osobowych</b></h2>
      <span>Serwis gromadzi i przetwarza dane Użytkowników na podstawie:</span>
      <ul>
        <li aria-level="1">
          <span>Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych)</span>
          <ul>
            <li aria-level="2">
              <span>art. 6 ust. 1 lit. a</span>
              <span />
              <span>osoba, której dane dotyczą wyraziła zgodę na przetwarzanie swoich danych osobowych w jednym lub większej liczbie określonych celów</span>

            </li>
            <li aria-level="2">
              <span>art. 6 ust. 1 lit. b</span>
              <span />
              <span>przetwarzanie jest niezbędne do wykonania umowy, której stroną jest osoba, której dane dotyczą, lub do podjęcia działań na żądanie osoby, której dane dotyczą, przed zawarciem umowy</span>

            </li>
            <li aria-level="2">
              <span>art. 6 ust. 1 lit. f</span>
              <span />
              <span>przetwarzanie jest niezbędne do celów wynikających z prawnie uzasadnionych interesów realizowanych przez administratora lub przez stronę trzecią</span>

            </li>
          </ul>
        </li>
        <li aria-level="1"><span>Ustawa z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. 2018 poz. 1000)</span></li>
        <li aria-level="1"><span>Ustawa z dnia 16 lipca 2004 r. Prawo telekomunikacyjne (Dz.U. 2004 nr 171 poz. 1800)</span></li>
        <li aria-level="1"><span>Ustawa z dnia 4 lutego 1994 r. o prawie autorskim i prawach pokrewnych (Dz. U. 1994 Nr 24 poz. 83)</span></li>
      </ul>
      <h2><b>§12 Okres przetwarzania danych osobowych</b></h2>
      <b> Dane osobowe podane dobrowolnie przez Użytkowników: </b>

      <span>Co do zasady wskazane dane osobowe są przechowywane wyłącznie przez okres świadczenia Usługi w ramach Serwisu przez Administratora. Są one usuwane lub anonimizowane w okresie do 30 dni od chwili zakończenia świadczenia usług.</span>

      <span>Wyjątek stanowi sytuacja, która wymaga zabezpieczenia prawnie uzasadnionych celów dalszego przetwarzania tych danych przez Administratora. W takiej sytuacji Administrator będzie przechowywał wskazane dane, od czasu żądania ich usunięcia przez Użytkownika, nie dłużej niż przez okres 3 lat w przypadku naruszenia lub podejrzenia naruszenia zapisów regulaminu serwisu przez Użytkownika.</span>

      <b> Dane anonimowe (bez danych osobowych) gromadzone automatycznie: </b>
      <br />
      <span> Anonimowe dane statystyczne, niestanowiące danych osobowych, są przechowywane przez Administratora w celu prowadzenia statystyk serwisu przez czas nieoznaczony.</span>
      <h2><b>§13 Prawa Użytkowników związane z przetwarzaniem danych osobowych</b></h2>
      <span>Serwis gromadzi i przetwarza dane Użytkowników na podstawie:</span>
      <ul>
        <li aria-level="1">
          <b>Prawo dostępu do danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo uzyskania dostępu do swoich danych osobowych, realizowane na żądanie złożone do Administratora.</span>

        </li>
        <li aria-level="1">
          <b>Prawo do sprostowania danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo żądania od Administratora niezwłocznego sprostowania danych osobowych, które są nieprawidłowe lub / oraz uzupełnienia niekompletnych danych osobowych, realizowane na żądanie złożone do Administratora.</span>

        </li>
        <li aria-level="1">
          <b>Prawo do usunięcia danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo żądania od Administratora niezwłocznego usunięcia danych osobowych, realizowane na żądanie złożone do Administratora W przypadku kont użytkowników, usunięcie danych polega na anonimizacji danych umożliwiających identyfikację Użytkownika. Administrator zastrzega sobie prawo wstrzymania realizacji żądania usunięcia danych w celu ochrony prawnie uzasadnionego interesu Administratora (np. w gdy Użytkownik dopuścił się naruszenia Regulaminu czy dane zostały pozyskane wskutek prowadzonej korespondencji).</span>

        </li>
        <li aria-level="1">
          <b>Prawo do ograniczenia przetwarzania danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo ograniczenia przetwarzania danych osobowych w przypadkach wskazanych w art. 18 RODO, m.in. kwestionowania prawidłowość danych osobowych, realizowane na żądanie złożone do Administratora.</span>

        </li>
        <li aria-level="1">
          <b>Prawo do przenoszenia danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo uzyskania od Administratora, danych osobowych dotyczących Użytkownika w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego, realizowane na żądanie złożone do Administratora.</span>

        </li>
        <li aria-level="1">
          <b>Prawo wniesienia sprzeciwu wobec przetwarzania danych osobowych</b>
          <br />
          <span>Użytkownikom przysługuje prawo wniesienia sprzeciwu wobec przetwarzania jego danych osobowych w przypadkach określonych w art. 21 RODO, realizowane na żądanie złożone do Administratora.</span>

        </li>
        <li aria-level="1">
          <b>Prawo wniesienia skargi</b>
          <br />
          <span>Użytkownikom przysługuje prawo wniesienia skargi do organu nadzorczego zajmującego się ochroną danych osobowych.</span>

        </li>
      </ul>
      <h2><b>§14 Kontakt do Administratora</b></h2>
      <span>Z Administratorem można skontaktować się w jeden z poniższych sposobów</span>
      <ul>
        <li aria-level="1">
          <b>Adres pocztowy</b>
          <span> - Active Management Sp. z o. o. sp. k., ul. Urzędnicza 16/2, 30-051 Kraków</span>
        </li>
        <li aria-level="1">
          <b>Adres poczty elektronicznej</b>
          <span> - info@actman.pl</span>
        </li>
        <li aria-level="1">
          <b>Połączenie telefoniczne</b>
          <span> - +48 12 290 12 50</span>
        </li>
        <li aria-level="1">
          <b>Formularz kontaktowy</b>
          <span> - dostępny pod adresem: www.actman.pl</span>
        </li>
      </ul>
      <h2><b>§15 Wymagania Serwisu</b></h2>
      <ul>
        <li aria-level="1"><span>Ograniczenie zapisu i dostępu do plików Cookie na Urządzeniu Użytkownika może spowodować nieprawidłowe działanie niektórych funkcji Serwisu.</span></li>
        <li aria-level="1"><span>Administrator nie ponosi żadnej odpowiedzialności za nieprawidłowo działające funkcje Serwisu w przypadku gdy Użytkownik ograniczy w jakikolwiek sposób możliwość zapisywania i odczytu plików Cookie.</span></li>
      </ul>
      <h2><b>§16 Linki zewnętrzne</b></h2>
      <span>W Serwisie - artykułach, postach, wpisach czy komentarzach Użytkowników mogą znajdować się odnośniki do witryn zewnętrznych, z którymi Właściciel serwisu nie współpracuje. Linki te oraz strony lub pliki pod nimi wskazane mogą być niebezpieczne dla Twojego Urządzenia lub stanowić zagrożenie bezpieczeństwa Twoich danych. Administrator nie ponosi odpowiedzialności za zawartość znajdującą się poza Serwisem.</span>
      <h2><b>§17 Zmiany w Polityce Prywatności</b></h2>
      <ul>
        <li aria-level="1"><span>Administrator zastrzega sobie prawo do dowolnej zmiany niniejszej Polityki Prywatności bez konieczności informowania o tym Użytkowników w zakresie stosowania i wykorzystywania danych anonimowych lub stosowania plików Cookie.</span></li>
        <li aria-level="1"><span>Wprowadzone zmiany w Polityce Prywatności będą publikowane na tej podstronie Serwisu.</span></li>
        <li aria-level="1"><span>Wprowadzone zmiany wchodzą w życie z chwilą ich publikacji.</span></li>
      </ul>
    </div>
  );
}

export default PrivacyPL;
